import { GitFork, MapTrifold, Target } from "@phosphor-icons/react";
import { Reveal } from "./Reveal";
import { Surface } from "./Surface";

/* Три шага лестницей: каждый следующий сдвинут вправо, как движение вперёд.
   Номер контурный, светится у границы, иконка отмечает суть шага. */
const STEPS = [
  {
    icon: MapTrifold,
    title: "Карта и цифра потерь",
    text: "Разбираю процесс: кто, что, чем и сколько раз делает. Потом считаю, сколько часов и денег съедает ручная часть. Получается цифра, а не ощущение. Этот шаг и есть бесплатный разбор.",
    tag: "бесплатно",
    offset: "",
  },
  {
    icon: Target,
    title: "Узкий MVP с метрикой",
    text: "Беру один вопрос и закрываю его целиком. До старта договариваемся, что считать результатом, иначе «вроде стало лучше» результатом не считается.",
    offset: "md:ml-16 lg:ml-28",
  },
  {
    icon: GitFork,
    title: "Дальше или стоп",
    text: "Если работает, расширяем. Если нет, говорю прямо и не тяну деньги.",
    offset: "md:ml-32 lg:ml-56",
  },
];

export const Method = () => (
  <ol className="flex flex-col gap-5">
    {STEPS.map((s, i) => {
      const Icon = s.icon;
      return (
        <li key={s.title} className={s.offset}>
          <Reveal delay={i * 0.08}>
            <Surface className="grid items-center gap-6 p-6 sm:grid-cols-[auto_1fr] sm:gap-10 sm:p-8">
              <span
                aria-hidden="true"
                className="font-display text-7xl font-medium leading-none text-transparent [-webkit-text-stroke:1.5px_rgba(156,200,255,0.85)] sm:text-8xl"
                style={{ textShadow: "0 0 36px rgba(62,139,255,0.8)" }}
              >
                {i + 1}
              </span>
              <div>
                <div className="flex flex-wrap items-center gap-3">
                  <Icon size={28} weight="duotone" className="text-accent-soft" />
                  <h3 className="h3 text-2xl">
                    <span className="sr-only">Шаг {i + 1}. </span>
                    {s.title}
                  </h3>
                  {s.tag && (
                    <span className="rounded-full bg-tag/12 px-3 py-1 text-sm font-medium text-tag">{s.tag}</span>
                  )}
                </div>
                <p className="mt-3 max-w-[640px] text-base text-muted">{s.text}</p>
              </div>
            </Surface>
          </Reveal>
        </li>
      );
    })}
  </ol>
);
